import { Builder } from '@builder.io/sdk';
import { ArticlesList } from './ArticlesList';
import { ARTICLES_LIST_NAME, SHOW_AS } from './ArticlesList.types';
import { BuilderInputOptions } from '@/types/builder';

// showIf callbacks use literal strings instead of SHOW_AS constants because
// Builder's editor evaluates these functions in its own runtime where imported
// constants may not resolve, causing conditional fields to never appear.
const ArticleListConfig = {
  name: ARTICLES_LIST_NAME,
  friendlyName: 'Articles List',
  description: 'A grid of articles with pagination.',
  inputs: [
    {
      name: 'showAs',
      friendlyName: 'Display Layout',
      type: 'string',
      enum: [
        { label: 'Cards grid', value: SHOW_AS.CARDS },
        { label: 'Simple list', value: SHOW_AS.LIST },
        { label: 'Hub article list', value: SHOW_AS.HUB_LIST },
      ],
      defaultValue: SHOW_AS.LIST,
      helperText:
        'Cards grid = image cards in a 3-column grid · Simple list = title + date rows · Hub article list = title + date rows with a "Go to article" button',
    },
    {
      name: 'title',
      friendlyName: 'Section Title',
      type: 'richText',
      defaultValue: 'More <span style="color: #fe5000">[HUB NAME]</span> articles',
      helperText:
        'Heading above the article list. Rich-text formatting (colours, bold) is visible in "Hub article list" mode — other modes display plain text only.',
    },
    {
      name: 'category',
      friendlyName: 'Filter by Category',
      type: 'reference',
      model: 'category',
      helperText: 'Optional — pick a category to show only its articles. Leave empty to show all articles.',
      showIf: (options: BuilderInputOptions) => options?.get('showAs') === 'hub-list',
    },
    {
      name: 'buttonText',
      friendlyName: 'Button Label',
      type: 'string',
      defaultValue: 'Go to article',
      helperText: "Text shown on each row's button.",
      showIf: (options: BuilderInputOptions) => options?.get('showAs') === 'hub-list',
    },
    {
      name: 'tagVariant',
      friendlyName: 'Tag Color',
      type: 'string',
      defaultValue: 'primary',
      enum: [
        { label: 'Orange (default)', value: 'primary' },
        { label: 'Purple (guides)', value: 'secondary' },
      ],
      helperText: 'Colour of the category tag on each card.',
      showIf: (options: BuilderInputOptions) => options?.get('showAs') === 'cards',
    },
  ],
};

Builder.registerComponent(ArticlesList, ArticleListConfig);
